import {useNavigate} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {Button} from '@chekin/guestapp-ui-kit';
import {PATHS} from 'routes/constants';
import {usePath} from 'hooks';

type Props = {
  onGoToKeyCards?: () => void;
};
function CompletePrintedCardContent({onGoToKeyCards}: Props) {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const {getFullPath} = usePath();

  return (
    <>
      <div>
        <div className="text-kiosko-l font-semibold text-[#333] mb-2 text-center">
          {t('your_keys_are_ready')}
        </div>
      </div>

      <div className="flex flex-col gap-14">
        <Button
          onClick={() => {
            navigate(getFullPath(PATHS.home));
          }}
          size="md"
          className="m-auto gap-[18px]"
          variant="outline"
        >
          {t('go_to_home')}
        </Button>

        <Button
          onClick={onGoToKeyCards}
          size="md"
          className="m-auto gap-[18px]"
          variant="outline"
        >
          {t('go_to_keycards')}
        </Button>
      </div>
    </>
  );
}

export {CompletePrintedCardContent};
